import { MdOutlineError } from 'react-icons/md';
import { CarGroundIcon } from '@icons';

export const CurriLegInfo = ({ trackingLink }: { trackingLink?: string | null }) => {
  return !trackingLink ? (
    <div className="w-max flex px-1 py-0.5 rounded-[4px] gap-1 bg-base-70">
      <div className="text-danger-30">
        <MdOutlineError size={16} />
      </div>
      <CarGroundIcon />
      <span className="text-s-r text-base-10">Tracking link is missing</span>
    </div>
  ) : null;
};
